// assets
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import PlayCircleOutlined from '@ant-design/icons/PlayCircleOutlined';
import WindowsOutlined from '@ant-design/icons/WindowsOutlined';
import DonutSmallOutlinedIcon from '@mui/icons-material/DonutSmallOutlined';
import VideoCameraOutlined from '@ant-design/icons/VideoCameraOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';

import {
  EVENTS_PAGE_NAME,
  EVENTS_PAGE_TITLE,
  TARGET_APP_BUILD,
  TARGET_APP_BUILD_VALUE
} from '@/constants/globalConstants';

// icons
const icons = {
  CalendarOutlined,
  PlayCircleOutlined,
  WindowsOutlined,
  VideoCameraOutlined,
  SettingsOutlinedIcon,
  DonutSmallOutlinedIcon,
  ShareOutlinedIcon,
  GroupOutlinedIcon
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

let other = {}
const backupOther = {
  id: 'main-group',
  type: 'group',
  children: [
    {
      id: 'clips',
      title: 'Backup Clips',
      type: 'item',
      url: '/backup',
      icon: icons.WindowsOutlined,
    },
  ]
}

const mainOther = {
  id: 'main-group',
  type: 'group',
  children: [
    {
      id: 'events',
      title: EVENTS_PAGE_TITLE,
      type: 'item',
      url: `/${EVENTS_PAGE_NAME}`,
      icon: icons.CalendarOutlined,
    },
    {
      id: 'key_moments',
      title: 'Key Moments',
      type: 'item',
      url: '/keymoments',
      icon: icons.PlayCircleOutlined,
    },
    {
      id: 'clips',
      title: 'Clips',
      type: 'item',
      url: '/clips',
      icon: icons.WindowsOutlined,
    },
    {
      id: 'renderingjob',
      title: 'Monitor',
      type: 'item',
      url: '/renderingjob',
      icon: icons.VideoCameraOutlined,
    },
    {
      id: 'rules',
      title: 'Automation',
      type: 'item',
      url: '/rules',
      icon: icons.SettingsOutlinedIcon
    },
    {
      id: 'social',
      title: 'Social',
      type: 'item',
      url: '/social',
      icon: icons.ShareOutlinedIcon,
    },
    {
      id: 'user',
      title: 'Users',
      type: 'item',
      url: '/users',
      icon: icons.GroupOutlinedIcon,
    },
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DonutSmallOutlinedIcon,
    }
  ]
};

if(TARGET_APP_BUILD === TARGET_APP_BUILD_VALUE.BACKUP){
  other = {...backupOther}
}else{
  other = {...mainOther}
}


export default other;
